import {Injectable} from "@angular/core";
import {Observable, ReplaySubject, BehaviorSubject, share} from "rxjs";
import {FUIResponsiveService} from "../page/responsive.service";
import {FUIBreakpoints} from "../page/breakpoints.model";

@Injectable()
export class FUINavLayoutService {
    private _activeFrame: BehaviorSubject<boolean>;
    public activeFrame$: Observable<boolean>;
    private _activeOverlay: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public activeOverlay$: Observable<boolean> = this._activeOverlay.asObservable();

    constructor(private responsiveService: FUIResponsiveService) {
        if (this.responsiveService.breakpointApplies(FUIBreakpoints.smallDown)) {
            this._activeFrame = new BehaviorSubject<boolean>(false);
            this.activeFrame$ = this._activeFrame.asObservable()
                .pipe(share({
                    connector: () => new ReplaySubject(1),
                    resetOnError: false,
                    resetOnComplete: false,
                    resetOnRefCountZero: false
                }));
        }
        else {
            this._activeFrame = new BehaviorSubject<boolean>(true);
            this.activeFrame$ = this._activeFrame.asObservable()
                .pipe(share({
                    connector: () => new ReplaySubject(1),
                    resetOnError: false,
                    resetOnComplete: false,
                    resetOnRefCountZero: false
                }));
        }

        if (this.responsiveService.breakpointApplies(FUIBreakpoints.smallDown)) {
            this._activeFrame.next(false);
        }
        else {
            this._activeFrame.next(true);
        }
    }

    /**
     * Toggle the "frame" of the site (the $navigation)
     * between visible and offscreen.
     */
    toggleFrame(state: boolean): void {
        this._activeFrame.next(state);
        if (this.responsiveService.breakpointApplies(FUIBreakpoints.smallDown)) {
            this.toggleOverlay(state);
        }
        // wait 500ms for the transition to finish before emitting window change
        setTimeout(() => this.responsiveService.emitWindowChange(), 500);
    }

    /**
     * Toggle the visibility of the screen overlay
     * @param {boolean} state
     */
    toggleOverlay(state: boolean): void {
        this._activeOverlay.next(state);
    }
}
